export enum SHEET_TABS_ID_SECTIONS {
  PROFIT = 'section-sheet-rentabilidade',
  WALLET = 'section-sheet-carteira',
  CHARTS = 'section-sheet-indicadores-graficos',
  CORRELATION = 'section-sheet-correlacao',
  MOVABLE_WINDOWS = 'section-janelas-moveis',
}

export const SHEET_TABS_SECTIONS = [
  { name: 'Rentabilidade', id: SHEET_TABS_ID_SECTIONS.PROFIT },
  { name: 'Carteira', id: SHEET_TABS_ID_SECTIONS.WALLET },
  { name: 'Indicadores Gráficos', id: SHEET_TABS_ID_SECTIONS.CHARTS },
  { name: 'Janelas Móveis', id: SHEET_TABS_ID_SECTIONS.MOVABLE_WINDOWS },
];

export const COMPARISON_ASSETS_TABS_SECTIONS = [
  { name: 'Rentabilidade', id: SHEET_TABS_ID_SECTIONS.PROFIT },
  { name: 'Correlação', id: SHEET_TABS_ID_SECTIONS.CORRELATION },
  { name: 'Indicadores Gráficos', id: SHEET_TABS_ID_SECTIONS.CHARTS },
  { name: 'Janelas Móveis', id: SHEET_TABS_ID_SECTIONS.MOVABLE_WINDOWS },
];

export const SHEET_B3_TABS_SECTIONS = [
  { name: 'Rentabilidade', id: SHEET_TABS_ID_SECTIONS.PROFIT },
  { name: 'Indicadores Gráficos', id: SHEET_TABS_ID_SECTIONS.CHARTS },
  { name: 'Janelas Móveis', id: SHEET_TABS_ID_SECTIONS.MOVABLE_WINDOWS },
];
